import { Callout } from "components/ui/callout";
import * as React from "react";

export interface IActionBarComponent {
    displayLabel: () => string;
    displayValue: () => string;
    editableContent: () => JSX.Element;
}

interface ActionBarComponentRendererProps {
    className?: string;
    actionBarObject: IActionBarComponent;
    setForceDismiss?: (forceDismiss: () => void) => void;
    setInitialFocus?: boolean;
    useNewLayout: boolean;
}

interface ActionBarComponentRendererState {
    show: boolean;
}

export class ActionBarComponentRenderer extends React.Component<
    ActionBarComponentRendererProps,
    ActionBarComponentRendererState
> {
    public static defaultUnspecifiedValue = "(none)";

    public constructor(p: ActionBarComponentRendererProps) {
        super(p);
        this.state = {
            show: false,
        };
        this.renderButton = this.renderButton.bind(this);
        this.onDismissDialog = this.onDismissDialog.bind(this);
        this.onOpen = this.onOpen.bind(this);
    }

    componentDidMount() {
        if (this.props.setForceDismiss) {
            this.props.setForceDismiss(this.onDismissDialog.bind(this));
        }
    }

    private getStaticHyperlinkText(): string {
        // Note: we could use our defaultUnspecifiedValue here,
        // but I intentionally want to know if a customer ever tells
        // us that "no value set" is showing up since it will be easier
        // to track down any issues.
        let value = this.props.actionBarObject.displayValue();

        if (!value || value.length == 0) {
            value = "no value set";
        }

        return value;
    }

    private renderButton(): JSX.Element {
        // If useNewLayout is true, render compact toolbar for small screens and legacy for large screens
        if (this.props.useNewLayout) {
            return (
                <div onClick={this.onOpen}>
                    <button
                        type="button"
                        className={
                            "rounded-full bg-zinc-100 px-3 py-1 flex items-center gap-2 shadow border border-zinc-200 text-sm font-medium text-zinc-800 hover:bg-zinc-200 transition"
                        }
                        aria-label={this.props.actionBarObject.displayLabel()}>
                        <div className="text-xs text-zinc-500">
                            {this.props.actionBarObject.displayLabel()}
                        </div>
                        <div className="font-semibold">
                            {this.getStaticHyperlinkText()}
                        </div>
                    </button>
                </div>
            );
        }
        // Fallback to legacy blue box if useNewLayout is false
        return (
            <div className={"action-bar-component" + " " + this.props.className}>
                <div>
                    <div className="action-bar-label">
                        {this.props.actionBarObject.displayLabel()}
                    </div>
                    <div className="action-bar-value">
                        <a href="#">{this.getStaticHyperlinkText()}</a>
                    </div>
                </div>
            </div>
        );
    }

    private onDismissDialog() {
        this.setState({ show: false });
    }

    private onOpen() {
        this.setState({ show: true });
    }

    public render() {
        return (
            <Callout
                renderButton={this.renderButton}
                forceClose={!this.state.show}
                onOpen={this.onOpen}>
                <div className="w-80">{this.props.actionBarObject.editableContent()}</div>
            </Callout>
        );
    }
}
